import ScaledExpressionExtension from './ScaledExpressionExtension';

export default ScaledExpressionExtension;
